import {supabase} from "../../../services/Supabase";

export const AuditsService = {
    get: async function(id: string) {
        let { data, error } = await supabase
            .from('audits')
            .select('*')
            .eq("id", id)
        return data
    },


    view: async function() {
        let { data, error } = await supabase
            .from('audits')
            .select('*')
        return data
    },

    create: async function(audit: any) {
        const { data, error } = await supabase
            .from('audits')
            .insert([
                { id: audit.id },
            ])
        return data
    },

    update: async function(id: string, audit: any) {
        const { data, error } = await supabase
            .from('audits')
            .update([
                { ...audit },
            ])
            .eq('id', id)
        return data
    },

    remove: async function(id: string)  {
        const { data, error } = await supabase
            .from('audits')
            .delete()
            .eq('id', id)
        return data
    }
}